/**
 * The narration pools — everything the combat log can say that is not the
 * tissue clause.
 *
 * The tissue clause comes from the wound tables, because *what a level-3 cut to
 * the thigh does* is one decision and it should be written down once. What is
 * here is the rest of AoD §12.1's chain: the declaration that opens a blow, the
 * defence or contact that answers it, and the status clauses that report the
 * state changes the sim actually made.
 *
 * Two rules the writing follows:
 *
 * - **Name the thing.** The weapon, the piece of armour, the part. *"The axe
 *   turns on his mail byrnie"* is a better line than *"the blow is blocked"*
 *   and it is also more honest, because the sim knows which byrnie.
 * - **Unflinching, not lurid.** AoD open question 2's stance: this is a
 *   dark-ages register, and it reports what happened. It does not linger.
 *
 * Validated at import by `NarrationPools.from`: two phrasings minimum per pool,
 * no unknown tokens, and no clause reaching for data its tuple does not carry
 * (a declaration cannot name the part — when a man swings, nobody yet knows
 * where it lands).
 */
import { assertPoolsCover, NarrationPools, reachableStatusKinds, } from '@annwn/sim';
import { ATTACK_PROFILES } from '../attackProfiles.js';
import { DECLARATIONS } from './declarations.js';
import { DEFENCES, CONTACTS } from './defences.js';
import { STATUSES } from './statuses.js';
export { DECLARATIONS } from './declarations.js';
export { DEFENCES, CONTACTS } from './defences.js';
export { STATUSES } from './statuses.js';
export const NARRATION_SOURCE = {
    declaration: DECLARATIONS,
    defence: DEFENCES,
    contact: CONTACTS,
    status: STATUSES,
};
export const NARRATION_POOLS = NarrationPools.from(NARRATION_SOURCE);
/**
 * The completeness lint, computed from the content and the sim's own event
 * vocabulary rather than from a maintained list.
 *
 * Every attack profile in the kit needs a declaration and every status the
 * clocks can emit needs a pool — so adding a creature with a new way of hurting
 * people, or a clock with a new threshold, fails on import rather than
 * printing a hole into a log nine thousand duels into an overnight run.
 */
assertPoolsCover(NARRATION_POOLS, {
    attacks: [...ATTACK_PROFILES.keys()],
    statuses: reachableStatusKinds(),
});
//# sourceMappingURL=index.js.map